import { Alert } from "react-bootstrap";
import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import TitleSlide from "../../components/Slides/templates/TitleSlide";
import StudentPicker from "../../components/global/StudentPicker";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";
import CodeSlide from "../../components/Slides/templates/CodeSlide";
import CodePen from "../../components/Codepen/Codepen";

export default function S03P01({ reveal }: ISlideObject) {
  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Semana 03 Parte 1"
      />
      <DefaultSlide title="Agenda">
        <div>
          <ul>
            <li>Repaso semana anterior</li>
            <li>CSS en profundidad</li>
            <li>Ejercicio HTML & CSS</li>
          </ul>
        </div>
      </DefaultSlide>
      <section>
        <TitleSlide title="Ejercicio de HTML & CSS" />
        <DefaultSlide title="Semana anterior">
          <img src="/images/S02/todo.png" alt="UI para aplicación to-do." />
        </DefaultSlide>
        <section>
          <p>
            A continuación se plantean algunas preguntas de repaso que hemos
            visto en clases anteriores. Para cada pregunta, reflexione si debe
            reforzar más los contenidos del curso.
          </p>
          <p className="fragment">
            Y lo que es más importante... Si hay algo que debamos cubrir o
            mejorar lo podemos hacer.
          </p>
        </section>
        <DefaultSlide title="Repaso HTML & CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>¿De qué forma se enlazan los estilos de CSS a una página web?</p>
            <StudentPicker number={1} />
            <div className="fragment">
              <p>
                ¿De qué forma se enlazan los estilos de CSS a las etiquetas de
                HTML?
              </p>
              <StudentPicker number={1} />
            </div>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Repaso HTML & CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Qué es un <code>div</code> y en qué se diferencia de otras
              etiquetas como <code>section</code>?
            </p>
            <StudentPicker number={1} />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Repaso HTML & CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Para qué sirve el atributo <code>class</code>?
            </p>
            <StudentPicker number={1} />
            <div className="fragment">
              <p>
                ¿Para qué sirve el atributo <code>id</code>?
              </p>
              <StudentPicker number={1} />
            </div>
            <div className="fragment">
              <p>¿Qué diferencia hay entre ambos atributos?</p>
              <StudentPicker number={1} />
            </div>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Repaso HTML & CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Qué es un <code>span</code>?
            </p>
            <StudentPicker number={1} />
          </div>
        </DefaultSlide>

        <DefaultSlide title="Repaso HTML & CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <div className="fragment">
              <p>
                ¿Para qué sirve la propiedad de CSS <code>padding</code>?
              </p>
              <StudentPicker number={1} />
            </div>
            <div className="fragment">
              <p>
                ¿Para qué sirve la propiedad de CSS <code>margin</code>?
              </p>
              <StudentPicker number={1} />
            </div>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Margin vs Padding">
          <div
            style={{ width: "100%", fontSize: "0.7em", textAlign: "center" }}
          >
            <div>
              <p>
                <img
                  src="/images/S03/marginpadding.jpg"
                  alt="Imagen para explicar diferencias entre margin y padding"
                />
              </p>
            </div>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Repaso HTML & CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>¿Qué es el DOM?</p>
            <StudentPicker number={1} />
          </div>
        </DefaultSlide>

        <DefaultSlide title="Repaso HTML & CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Para qué sirve la propiedad de CSS <code>display</code>?
            </p>
            <StudentPicker number={1} />
          </div>
        </DefaultSlide>
      </section>

      <section>
        <TitleSlide title="CSS en profundidad" />
        <DefaultSlide title="CSS en profundidad">
          <div>
            <p>
              CSS es un lenguaje de estilos que nos permite darle un aspecto
              visual a nuestras páginas web.
            </p>
            <p className="fragment">
              En esta sección veremos algunas propiedades avanzadas de CSS.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="La propiedad display">
          <div>
            <p>
              La propiedad <code>display</code> nos permite cambiar el
              comportamiento de visualización de un elemento. Existen dos
              posibles valores por defecto dependiendo del tipo de elemento:
            </p>
            <ul>
              <li>block</li>
              <li>inline</li>
            </ul>
            <p className="fragment">Pero pueden haber más valores...</p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="La propiedad display">
          <div>
            <p>
              Otros valores de la propiedad <code>display</code> son:
            </p>
            <ul>
              <li>inline-block... no usar...</li>
              <li>flex</li>
              <li>grid</li>
            </ul>
          </div>
        </DefaultSlide>
        <section>
          <CodePen
            penId="PwomLNj"
            title="Display Property"
            editable={true}
            defaultTab="html"
          />
        </section>
        <section data-background-color="blue">
          <h3>Pueden jugar con los valores de la propiedad en este enlace</h3>
          <a
            href="https://www.w3schools.com/cssref/playdemo.php?filename=playcss_display&preval=contents"
            target="_blank"
            rel="noreferrer"
          >
            https://www.w3schools.com/cssref/playdemo.php?filename=playcss_display&preval=contents
          </a>
        </section>
        <DefaultSlide title="Tarea: Display Flex vs Grid">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <Alert variant="success">
              Objetivo: Aprender sobre propiedades de renderización más utilizadas en CSS. <br />
              <span style={{ fontSize: "0.5em" }}>Vence: 12 Marzo 2025</span>
            </Alert>
            <p>
              Investigar las diferencias y características de{" "}
              <code>display: flex</code> y <code>display: grid</code>. Deben
              incluir:
            </p>
            <ul>
              <li>Características</li>
              <li>Principales diferencias</li>
              <li>casos en los que es más conveniente utilizar uno u otro.</li>
              <li>Ejemplos de uso.</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Tarea 01. Display Flex vs Grid">
          <div>
            <p>
              Pueden utilizar la documentación oficial de Mozilla Developer
              Network (MDN) y otros recursos en línea.
            </p>
            <ul>
              <li>
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Basic_Concepts_of_Flexbox"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Flexbox - MDN
                </a>
              </li>
              <li>
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Grid_Layout"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Grid - MDN
                </a>
              </li>
            </ul>
            <p>Deben agregar un documento HTML en su repositorio llamado S03T01.html, en el cuál deben incluir los contenidos de la tarea.</p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Las pseudoclases de CSS">
          <div>
            <table
              style={{ width: "100%", fontSize: "0.7em", textAlign: "left" }}
            >
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>:hover</td>
                  <td>
                    Aplica estilos cuando el usuario pasa el cursor sobre un
                    elemento.
                  </td>
                  <td>
                    <code>a:hover &#123; color: red; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>:focus</td>
                  <td>
                    Aplica estilos cuando un elemento ha recibido el foco.
                  </td>
                  <td>
                    <code>input:focus &#123; border-color: blue; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>:nth-child(n)</td>
                  <td>Aplica estilos al enésimo hijo de un elemento.</td>
                  <td>
                    <code>li:nth-child(2) &#123; color: green; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>:not(selector)</td>
                  <td>
                    Aplica estilos a todos los elementos que no coinciden con el
                    selector.
                  </td>
                  <td>
                    <code>:not(p) &#123; color: gray; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>:last-child</td>
                  <td>Aplica estilos al último hijo de un elemento.</td>
                  <td>
                    <code>li:last-child &#123; font-weight: bold; &#125;</code>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Los pseudoelementos de CSS">
          <div>
            <table
              style={{ width: "100%", fontSize: "0.7em", textAlign: "left" }}
            >
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Ejemplo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>::before</td>
                  <td>Inserta contenido antes del contenido de un elemento.</td>
                  <td>
                    <code>p::before &#123; content: "Antes"; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>::after</td>
                  <td>
                    Inserta contenido después del contenido de un elemento.
                  </td>
                  <td>
                    <code>p::after &#123; content: "Después"; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>::first-line</td>
                  <td>Aplica estilos a la primera línea de un elemento.</td>
                  <td>
                    <code>p::first-line &#123; color: red; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>::first-letter</td>
                  <td>Aplica estilos a la primera letra de un elemento.</td>
                  <td>
                    <code>p::first-letter &#123; font-size: 2em; &#125;</code>
                  </td>
                </tr>
                <tr>
                  <td>::selection</td>
                  <td>
                    Aplica estilos a la parte de un elemento que ha sido
                    seleccionada por el usuario.
                  </td>
                  <td>
                    <code>::selection &#123; background: yellow; &#125;</code>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Diferencias entre pseudoclases y pseudoelementos">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Las pseudoclases y los pseudoelementos son dos conceptos
              diferentes en CSS:
            </p>
            <ul>
              <li>
                <strong>Pseudoclases</strong>: Se utilizan para definir un
                estado especial de un elemento. Se escriben con un solo dos
                puntos (<code>:</code>).
              </li>
              <li>
                <strong>Pseudoelementos</strong>: Se utilizan para definir un
                estilo a una parte específica de un elemento. Se escriben con
                dos puntos (<code>::</code>).
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="La propiedad position">
          <div>
            <p>
              La propiedad <code>position</code> en CSS nos permite especificar
              cómo se posiciona un elemento en el documento.
            </p>
            <ul>
              <li>
                <strong>static</strong>: Es el valor por defecto. El elemento se
                posiciona según el flujo normal del documento.
              </li>
              <li>
                <strong>relative</strong>: El elemento se posiciona relativo a
                su posición original.
              </li>
              <li>
                <strong>absolute</strong>: El elemento se posiciona relativo a
                su contenedor más cercano que no tenga la posición{" "}
                <code>static</code>.
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="La propiedad position">
          <div>
            <p>
              La propiedad <code>position</code> en CSS nos permite especificar
              cómo se posiciona un elemento en el documento.
            </p>
            <ul>
              <li>
                <strong>fixed</strong>: El elemento se posiciona relativo a la
                ventana del navegador y no se mueve al hacer scroll.
              </li>
              <li>
                <strong>sticky</strong>: El elemento se comporta como{" "}
                <code>relative</code> hasta que se desplaza a una posición
                específica en la ventana, donde se comporta como{" "}
                <code>fixed</code>.
              </li>
            </ul>
            <a
              href="https://www.w3schools.com/Css/css_positioning.asp"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.w3schools.com/Css/css_positioning.asp
            </a>
          </div>
        </DefaultSlide>
        <DefaultSlide title="La propiedad z-index">
          <div>
            <p>
              La propiedad <code>z-index</code> en CSS controla el orden de apilamiento de los elementos posicionados (aquellos con <code>position</code> distinto de <code>static</code>).
            </p>
            <ul>
              <li>
          <strong>Valores positivos</strong>: Los elementos con valores de <code>z-index</code> más altos se apilan sobre los elementos con valores más bajos.
              </li>
              <li>
          <strong>Valores negativos</strong>: Los elementos con valores de <code>z-index</code> negativos se apilan debajo de los elementos con valores más altos.
              </li>
            </ul>
            <p className="fragment">
              Nota: <code>z-index</code> solo funciona en elementos posicionados (con <code>position</code> distinto de <code>static</code>).
            </p>
          </div>
        </DefaultSlide>

        <DefaultSlide title="CSS Counters">
          <div>
            <p>
              Los contadores en CSS nos permiten crear listas numeradas
              personalizadas. Se utilizan junto con las propiedades{" "}
              <code>counter-reset</code> y <code>counter-increment</code>.
            </p>
            <ul>
              <li>
                <strong>counter-reset</strong>: Inicializa un contador.
              </li>
              <li>
                <strong>counter-increment</strong>: Incrementa el valor de un
                contador.
              </li>
            </ul>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Ejemplo de CSS Counters">
          <div>
            <p>Ejemplo:</p>
            <pre>
              <code className="language-css hljs">
                {`ol {
  counter-reset: item;
}
li {
  counter-increment: item;
}
li::before {
  content: counter(item) ". ";
}`}
              </code>
            </pre>

            <a
              href="https://www.w3schools.com/Css/css_counters.asp"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.w3schools.com/Css/css_counters.asp
            </a>
          </div>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="CSS avanzado" />
        <section>Autoría. Algunos de los contenidos a continuación fueron tomados de las presentaciones preparadas por el profesor Isaac Alpizar.</section>
        <DefaultSlide title="CSS Variables">
          <div>
            <p>
              Las variables en CSS nos permiten definir valores que pueden ser
              reutilizados en todo el documento.
            </p>
            <p className="fragment">
              Se definen utilizando la notación <code>--nombre-variable</code>.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="CSS Variables">
          <div>
            <p>
              Para utilizar una variable en CSS, se utiliza la función{" "}
              <code>var()</code>.
            </p>
            <p className="fragment">
              <code>var(--nombre-variable)</code>
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="CSS Variables">
          <div>
            <p>
              ¿Qué beneficios principales le encuentran a las variables de CSS?
            </p>
            <StudentPicker number={1} />
            <ul>
              <li className="fragment">Reutilización de valores y simplificación del código.</li>
              <li className="fragment">Orden al permitir tener valores en un mismo lugar.</li>
              <li className="fragment">Temas!!</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Pesos de hojas de estilo">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              En CSS, los estilos pueden provenir de diferentes fuentes y tienen diferentes niveles de prioridad. Los principales son:
            </p>
            <ul>
              <li><strong>Autor</strong>: Los estilos definidos por el autor de la página web.</li>
              <li><strong>Usuario</strong>: Los estilos definidos por el usuario a través de configuraciones del navegador.</li>
              <li><strong>Agente de usuario</strong>: Los estilos predeterminados del navegador.</li>
            </ul>
            <p className="fragment">
              La prioridad de los estilos sigue el siguiente orden: <strong>Agente de usuario</strong> &lt; <strong>Usuario</strong> &lt; <strong>Autor</strong>.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Especificidad en CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              La especificidad en CSS determina qué reglas de estilo se aplican a un elemento cuando hay múltiples reglas que podrían aplicarse.
            </p>
            <ul>
              <li>
          <strong>Inline styles</strong> (atributo style en HTML) tienen la mayor especificidad.
              </li>
              <li>
          <strong>ID selectors</strong> tienen una especificidad alta.
              </li>
              <li>
          <strong>Class, attribute, y pseudo-class selectors</strong> tienen una especificidad media.
              </li>
              <li>
          <strong>Element y pseudo-element selectors</strong> tienen una especificidad baja.
              </li>
            </ul>
            <p className="fragment">
              La especificidad se calcula sumando los valores de cada tipo de selector en la regla.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Especificidad en CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Qué regla de estilo se aplicará en el siguiente caso?
            </p>
            <pre>
              <code className="language-html hljs">
                {`<style>
  p {
    color: red;
  }
  .texto {
    color: blue;
  }
</style>
<p class="texto" style="color: green;">Hola mundo</p>`}
              </code>
            </pre>
            <StudentPicker number={1} />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Especificidad en CSS">
          <div>
            <p>
              La especificidad de los selectores se puede calcular de la siguiente manera:
            </p>
            <ul>
              <li>Se cuenta el número de atributos de ID en el selector.</li>
              <li>Se cuenta el número de clases, pseudoclases y atributos del selector.</li>
              <li>Se cuenta el número de nombres de elementos en el selector.</li>
            </ul>
            <a href="https://www.w3schools.com/css/css_specificity.asp" target="_blank" rel="noopener noreferrer">https://www.w3schools.com/css/css_specificity.asp</a>
          </div>
        </DefaultSlide>
        <section>
          <p>¿Cuál es la mejor forma de nombrar clases?</p>
        </section>
        <DefaultSlide title="Nomenclaturas CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <Alert variant="success">
              Objetivo: Aprender sobre mejores prácticas para el nombramiento de clases. <br />
              <span style={{ fontSize: "0.5em" }}>Vence: 12 Marzo 2025</span>
            </Alert>
            <p>
              En el mismo documento HTML de la tarea 1 de la semana, incluya un apartado con las mejores prácticas para el nombramiento de clases en CSS. Debe mencionar:
            </p>
            <ul>
              <li>Diferentes propuestas para nomenclatura CSS</li>
              <li>Ventajas y desventajas de cada propuesta</li>
            </ul>
            <p>Puede utilizar una tabla para comparar cada propuesta.</p>
          </div>
        </DefaultSlide>
      </section>

      <section>
        <TitleSlide title="Ejercicio HTML & CSS" />
        <DefaultSlide title="Ejercicio HTML & CSS">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              En su computadora, cree un documento HTML llamado practica.html y cree la siguiente estructura de HTML.
            <img src="/images/S03/exercise.png" alt="" />
            </p>
          </div>
        </DefaultSlide>
      </section>

      <ImageSlide image="/images/S03/dancing3.gif" title="¡Fin de la clase!">
        <p>Recuerda completar todos los contenidos de la semana.</p>
        {/* <button className="btn btn-success">Marcar como completo</button> */}
      </ImageSlide>
    </>
  );
}
